export const DEFAULT_PROCESS_CHUNKING_STRATEGY: string = 'ChunkByStepNumber';

export const DEFAULT_SUB_CHUNKING_STRATEGY: string = 'ChunkByUniqueKeyList';

export interface ProcessSupervisionRatingButton {
  value: number;
  label: string;
  color?: string;
}

export const DEFAULT_RATING_BUTTONS: ProcessSupervisionRatingButton[] = [
  { value: -1, label: 'Incorrect', color: 'danger' },
  { value: 1, label: 'Correct', color: 'success' },
];

export const DEFAULT_SUB_CHUNKING_STRATEGY_PARAMS: any = {
  keys: ['thought', 'action', 'action_input', 'observation'],
  edit_mask: [1, 1, 1, 0],
};

export const TOOLS: string[] = [
  'calculator',
  'date',
  'current_weather',
  'historical_weather',
  'wiki_search',
  'wolfram_alpha',
  'google_search',
  'time_series_intraday',
  'time_series_daily',
  'ticker_search',
  'python_interpreter',
  'finish',
];

export interface ProcessSupervisionField {
  fieldId: string;
  label: string;
  description: string;
  collectForRatingValues: number[];
  required: boolean;
  type: 'markdown' | 'plaintext';
  options?: { value: string; label: string }[];
}

export const DEFAULT_FIELDS_TO_COLLECT: ProcessSupervisionField[] = [
  {
    fieldId: 'rewrite',
    label: 'Rewrite',
    description: 'Please provide a rewrite suggestion.',
    collectForRatingValues: [-1],
    required: true,
    type: 'markdown',
  },
  {
    fieldId: 'rewriteReason',
    label: 'Rewrite Reason',
    description: 'Please provide a reason for your rewrite suggestion.',
    collectForRatingValues: [-1],
    required: true,
    type: 'plaintext',
  },
];

export const DEFAULT_EXPERIMENTAL_TOOL_USE_FIELDS_TO_COLLECT: ProcessSupervisionField[] = [
  {
    fieldId: 'rewrite',
    label: 'Rewrite',
    description: 'Please provide a rewrite suggestion.',
    collectForRatingValues: [-1],
    required: true,
    type: 'markdown', // NOTE: markdown or plain text. Markdown will use milkdown. Plaintext will just use textbox.
  },
];

export interface ProcessSupervisionChunk {
  content: string;
  rating?: number;
  rewrite?: string;
  [key: string]: any;
}
